import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

import './ProductReceiving.scss'
import { redirect } from '../../common/utils/redirectionUtils'
import {
  ADD_PRODUCT_RECEIVING_STAGES,
  BILL_DETAILS_FIELDS,
  PAGE_CONST,
  PAYMENT_DETAILS_FIELDS,
  PAYMENT_MODE_OPTIONS_PRODUCT_RECEIVING,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  PRODUCT_DETAIL_FIELDS,
  PRODUCT_RECEIVING_TYPE,
} from '../../common/constant/page-constant'
import { formatProductListLabel } from '../../common/utils/productUtils'
import Card from '../Common/Card/Card'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import TrashIcon from '../../assets/TrashIcon'
import ArrowDown from '../../assets/ArrowDown'
import AddProduct from './AddProduct'
import ViewProduct from './ViewProduct'
import WizardSteps from '../../components/WizardSteps/WizardSteps'
import {
  HEADER_CONFIG,
  HEADER_CONST,
  WIZARD_STEPS,
} from '../../common/constant/common-constant'
import AddIcon from '../../assets/AddIcon'
import CloseIcon from '../../assets/CloseIcon'
import Alert from '../../components/Alert/Alert'
import {
  addProductReceivingHelper,
  getInvoiceDetailsHelper,
  getMedicalCategoryHelper,
  getProductDataHelper,
  getProductReceivingHelper,
  getProductsHelper,
  getSuppliersHelper,
  updateProductDataHelper,
  updateSuppliersHelper,
  updateProductReceivingStatusHelper,
  deleteProductReceivingHelper,
} from '../../helper/home-helper'
import { addProductReceivingAlertAction } from '../../modules/actions/action'
import ProductReceivingBlack from '../../assets/ProductReceivingBlack'
import ViewInventory from '../ManageInventory/ViewInventory'
import Header from '../Common/Header/Header'
import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import CheckPrimaryIcon from '../../assets/CheckPrimaryIcon'
import AcknowledgeScreen from '../Common/AcknowledgeScreen/AcknowledgeScreen'
import PopupCard from '../Common/PopupCard/PopupCard'
import AddProductReceiving from './AddProductReceiving'
import ProductReceivingFilter from './components/ProductReceivingFilter'
import usePagination from '../../common/hooks/usePagination'
import Pagination from '../../components/PaginationComponent/Pagination'

function ProductReceiving(props) {
  const navigate = useNavigate()
  const isMobile = useCheckMobileScreen()

  const [viewDrawer, setViewDrawer] = useState(false)
  const [open, setOpen] = useState(false)
  const [isViewInventoryActive, setViewInventoryActive] = useState(false)
  const [addProductReceivingAlert, setAddProductReceivingAlert] =
    useState(false)
  const [productReceivingData, setProductReceivingData] = useState(undefined)
  const [stats, setStats] = useState({})
  const [invoiceData, setInvoiceData] = useState(null)
  const [editingData, setEditingData] = useState(null)
  const [activeReceivingTab, setActiveReceivingTab] = useState(
    PRODUCT_RECEIVING_TYPE.HOLD
  )
  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.PRODUCT_RECEIVING,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => redirect(navigate, PAGE_CONST.HOME),
  })
  const [loginData, setLoginData] = useState({})
  const [permissions, setPermissions] = useState({})
  const [serverError, setServerError] = useState(undefined)
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false)
  const [deleteInvoicePopup, setDeleteInvoicePopup] = useState(false)
  const [isDeletingInvoice, setIsDeletingInvoice] = useState(false)
  const [confirmInvoicePopup, setConfirmInvoicePopup] = useState(false)
  const [isConfirmingInvoice, setIsConfirmingInvoice] = useState(false)
  const [filterOptions, setFilterOptions] = useState({ search: '' })
  const pagination = usePagination({ initialPage: 1, initialLimit: 20 })

  // Alert modal state (replaces browser alert popups)
  const [alertModal, setAlertModal] = useState({
    show: false,
    header: '',
    body: '',
    onClose: null,
  })
  const showAlertModal = (header, body, onClose = null) =>
    setAlertModal({ show: true, header, body, onClose })
  const handleCloseAlertModal = () => {
    const cb = alertModal.onClose
    setAlertModal({ show: false, header: '', body: '', onClose: null })
    if (cb) cb()
  }

  const updateFilterOptions = (newOptions) => {
    setFilterOptions((prev) => ({
      ...prev,
      ...newOptions,
    }))
    pagination.goToPage(1)
  }

  useEffect(() => {
    let addProductReceivingAlert = props.alert?.addProductReceivingAlert
    setAddProductReceivingAlert(addProductReceivingAlert)
  }, [props.alert?.addProductReceivingAlert])

  useEffect(() => {
    setLoginData(props.loginData)

    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.reduce((acc, permission) => {
        acc.features = {
          ...acc.features,
          ...permission.features,
        }

        return acc
      }, {})

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  useEffect(() => {
    if (!open && !isViewInventoryActive) {
      handleHeaderConfigUpdate(HEADER_CONST.PRODUCT_RECEIVING, () =>
        redirect(navigate, PAGE_CONST.HOME)
      )
      return
    }

    if (open) {
      handleHeaderConfigUpdate(HEADER_CONST.ADD_PRODUCT_RECEIVING, () =>
        handleDrawerToggle()
      )
    } else if (isViewInventoryActive) {
      handleHeaderConfigUpdate(HEADER_CONST.VIEW_PRODUCT_RECEIVING, () =>
        setViewInventoryActive(!isViewInventoryActive)
      )
    }
  }, [open, isViewInventoryActive])

  // Server-side status filter, search and pagination all drive this fetch.
  useEffect(() => {
    getProductReceiving()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page, pagination.limit, activeReceivingTab, filterOptions])

  const handleHeaderConfigUpdate = (title, handleBackFunc) => {
    setHeaderOptions({
      [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
      [HEADER_CONFIG.TITLE]: title,
      [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => handleBackFunc(),
    })
  }

  const getProductReceiving = () => {
    getProductReceivingHelper(
      {},
      {
        ...pagination.getQueryParams(),
        status: activeReceivingTab,
        search: filterOptions.search || '',
      }
    )
      .then((res) => {
        setStats(res.stats)
        setProductReceivingData(res.product_receivings || [])
        if (res.pagination?.count != null)
          pagination.setTotalItems(res.pagination.count)
        if (res.pagination?.total_pages != null)
          pagination.setTotalPages(res.pagination.total_pages)
      })
      .catch((err) => {
        setStats({})
        setProductReceivingData([])
      })
  }

  // Refetch after a mutation. If the current page just lost its last row,
  // step back one page first — the backend 404s on an out-of-range page.
  const refreshReceivings = () => {
    if (productReceivingData?.length === 1 && pagination.page > 1) {
      pagination.goToPage(pagination.page - 1) // effect refetches
    } else {
      getProductReceiving()
    }
  }

  const clearServerError = () => {
    setServerError(undefined)
  }

  const handleSubmit = async (data) => {
    setServerError(undefined)

    try {
      let res = await addProductReceivingHelper(data)

      props.addProductReceivingAlertAction(true)
      setTimeout(() => {
        props.addProductReceivingAlertAction(false)
      }, 5000)
      getProductReceiving()
      handleDrawerToggle()
    } catch (errMsg) {
      setServerError(errMsg)
      console.error('Submit error:', errMsg)
    }
  }

  const getInvoiceDetails = (id) => {
    if (!id) {
      return
    }

    getInvoiceDetailsHelper(id)
      .then((res) => {
        setInvoiceData(res)
        setViewInventoryActive(true)
      })
      .catch((err) => {
        // Handle error silently
      })
  }

  const handleDrawerToggle = () => {
    setViewDrawer(!viewDrawer)
    setOpen(!open)
    if (open) {
      setEditingData(null)
    }
  }

  const handleAddNewReceiving = () => {
    navigate('/home/productReceiving/new')
  }

  const handleCardAction = (action, productReceiving) => {
    switch (action) {
      case 'EDIT':
        handleEditProductReceiving(productReceiving)
        break
      case 'CONFIRM':
        handleConfirmProductReceiving(productReceiving)
        break
      case 'REMOVE':
        handleRemoveInvoice(productReceiving)
        break
      case 'DOWNLOAD':
        handleDownloadInvoice(productReceiving)
        break
      case 'PRINT':
        handlePrintInvoice(productReceiving)
        break
      default:
        break
    }
  }

  const handleEditProductReceiving = async (productReceiving) => {
    navigate(`/home/productReceiving/edit/${productReceiving.id}`)
  }

  const handleConfirmProductReceiving = (productReceiving) => {
    setConfirmInvoicePopup(productReceiving)
  }

  const handleConfirmInvoice = async (productReceiving) => {
    if (isConfirmingInvoice) {
      showAlertModal(
        'Please Wait',
        'Another confirm operation is in progress. Please wait.'
      )
      return
    }

    if (!loginData || !loginData.id) {
      showAlertModal(
        'Error',
        'Unable to identify logged-in user. Please refresh and try again.'
      )
      return
    }

    setIsConfirmingInvoice(true)

    try {
      await updateProductReceivingStatus(
        productReceiving.id,
        PRODUCT_RECEIVING_TYPE.RECEIVED,
        loginData.id
      )

      setConfirmInvoicePopup(false)
    } catch (error) {
      showAlertModal(
        'Error',
        `Failed to confirm invoice: ${error}. Please try again.`
      )
    } finally {
      setIsConfirmingInvoice(false)
    }
  }

  const handleRemoveInvoice = (productReceiving) => {
    setDeleteInvoicePopup(productReceiving)
  }

  const handleDeleteInvoice = async (productReceiving) => {
    if (isDeletingInvoice) {
      showAlertModal(
        'Please Wait',
        'Another delete operation is in progress. Please wait.'
      )
      return
    }

    setIsDeletingInvoice(true)

    try {
      const requestData = {
        product_receiving_id: productReceiving.id,
      }
      const result = await deleteProductReceivingHelper(requestData)

      setDeleteInvoicePopup(false)
      refreshReceivings()
      showAlertModal('Success', `${result.message}!`)
    } catch (error) {
      showAlertModal(
        'Error',
        `Failed to delete invoice: ${error}. Please try again.`
      )
    } finally {
      setIsDeletingInvoice(false)
    }
  }

  const updateProductReceivingStatus = async (
    id,
    newStatus,
    receiverId = null
  ) => {
    if (isUpdatingStatus) {
      showAlertModal(
        'Please Wait',
        'Another status update is in progress. Please wait.'
      )
      return
    }

    setIsUpdatingStatus(true)

    try {
      const requestData = {
        product_receiving_id: id,
        status: newStatus,
      }

      if (receiverId) {
        requestData.received_by_user_id = receiverId
      }

      await updateProductReceivingStatusHelper(requestData)

      // Confirming a HOLD moves it to the RECEIVED tab, so it leaves the
      // current list — step back a page if it was the last row.
      refreshReceivings()
    } catch (error) {
      showAlertModal(
        'Error',
        `Failed to update status: ${error}. Please try again.`
      )
    } finally {
      setIsUpdatingStatus(false)
    }
  }

  const handleDownloadInvoice = async (productReceiving) => {
    const data = await getInvoiceDetailsHelper(productReceiving.id)
    if (data) {
      downloadInvoiceAsPDF(data)
    }
  }

  const handlePrintInvoice = async (productReceiving) => {
    const data = await getInvoiceDetailsHelper(productReceiving.id)
    if (data) {
      printInvoice(data)
    }
  }

  const downloadInvoiceAsPDF = async (data) => {
    const container = document.createElement('div')
    container.style.position = 'fixed'
    container.style.left = '-10000px'
    container.style.top = '0'
    container.style.width = '1100px'
    container.style.background = '#ffffff'
    container.innerHTML = generateInvoiceHTML(data, { embedBody: false })
    document.body.appendChild(container)

    try {
      const canvas = await html2canvas(container, {
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        scale: window.devicePixelRatio * 2 || 2,
        backgroundColor: '#ffffff',
      })

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width
      const pageHeight = pdf.internal.pageSize.getHeight()

      if (pdfHeight <= pageHeight) {
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
      } else {
        let position = 0
        let remaining = pdfHeight
        while (remaining > 0) {
          pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight)
          remaining -= pageHeight
          if (remaining > 0) {
            pdf.addPage()
            position -= pageHeight
          }
        }
      }

      pdf.save(`invoice-${data.invoice_number}.pdf`)
      showAlertModal(
        'Success',
        `Invoice ${data.invoice_number} downloaded successfully!`
      )
    } catch (err) {
      console.error('PDF generation error:', err)
      showAlertModal(
        'Error',
        'Failed to generate PDF. Please try again.'
      )
    } finally {
      document.body.removeChild(container)
    }
  }

  const formatInvoiceDate = (dateString) => {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    const month = monthNames[date.getMonth()]
    const year = String(date.getFullYear()).slice(-2)
    return `${day}-${month}-${year}`
  }

  const formatInvoiceTime = (timeString) => {
    if (!timeString) return 'N/A'
    const str = String(timeString)

    const hmsAmPm = str.match(/(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)/i)
    if (hmsAmPm) {
      return `${parseInt(hmsAmPm[1], 10)}:${hmsAmPm[2]}:${hmsAmPm[3]} ${hmsAmPm[4].toUpperCase()}`
    }

    const hms = str.match(/(\d{1,2}):(\d{2}):(\d{2})/)
    if (hms) {
      let h = parseInt(hms[1], 10)
      const ampm = h >= 12 ? 'PM' : 'AM'
      h = h % 12 || 12
      return `${h}:${hms[2]}:${hms[3]} ${ampm}`
    }

    const date = new Date(str)
    if (!isNaN(date.getTime())) {
      let h = date.getHours()
      const m = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      const ampm = h >= 12 ? 'PM' : 'AM'
      h = h % 12 || 12
      return `${h}:${m}:${s} ${ampm}`
    }

    return str
  }

  const printInvoice = (data) => {
    const printWindow = window.open('', '_blank')
    const content = generateInvoiceHTML(data)
    printWindow.document.write(content)
    printWindow.document.close()
    printWindow.print()
  }

  const generateInvoiceHTML = (data, options = {}) => {
    const { embedBody = true } = options
    const vendorInfo = data.vendor_details || data.vendor || null
    const hasVendor = !!vendorInfo
    const pharmaInfo = data.pharma_details || null
    const hasMultiSupplier = data.product_details?.some((p) => p.manufacturer_name && p.manufacturer_name !== pharmaInfo?.name)

    const headerEntity = hasVendor
      ? { name: vendorInfo.name, contact: vendorInfo.contact }
      : pharmaInfo && !hasMultiSupplier
      ? { name: pharmaInfo.name, contact: pharmaInfo.mobile_no }
      : null

    let totalQty = 0
    let totalBonusQty = 0
    let totalSubtotalSum = 0

    const rows = (data.product_details || [])
      .map((product, index) => {
        const quantity = parseFloat(product.quantity || 0)
        const bonusQty = parseFloat(product.bonus_quantity || 0)
        const cpu = parseFloat(product.cost_per_unit || 0)
        const rpu = parseFloat(product.rate_per_unit || 0)
        const subtotal = quantity * cpu

        totalQty += quantity
        totalBonusQty += bonusQty
        totalSubtotalSum += subtotal

        let formattedName = formatProductListLabel(
          {
            name: product.product_name || '',
            size: product.size,
            dose: product.dose,
            strength: product.strength,
            category: product.category,
          },
          { includeCategory: false }
        )
        if (!product.is_approved) formattedName += ' *'

        return `
          <tr>
            <td>${index + 1}</td>
            <td class="td-wrap">${formattedName}</td>
            <td>${product.category || ''}</td>
            <td>${product.batch_number || ''}</td>
            <td>${product.expiry_date ? formatInvoiceDate(product.expiry_date) : ''}</td>
            <td>${quantity}</td>
            <td>${bonusQty}</td>
            <td class="text-right">${cpu.toFixed(2)}</td>
            <td class="text-right">${rpu.toFixed(2)}</td>
            <td class="text-right">${subtotal.toFixed(2)}</td>
            ${(hasVendor || hasMultiSupplier) ? `<td>${product.manufacturer_name || ''}</td>` : ''}
          </tr>
        `
      })
      .join('')

    const totalRow = `
      <tr class="total-row">
        <td colspan="5" class="text-right"><strong>Total</strong></td>
        <td><strong>${totalQty}</strong></td>
        <td><strong>${totalBonusQty}</strong></td>
        <td colspan="2"></td>
        <td class="text-right"><strong>${totalSubtotalSum.toFixed(2)}</strong></td>
        ${(hasVendor || hasMultiSupplier) ? '<td></td>' : ''}
      </tr>`

    const paymentModeLabel = data.payment_mode
      ? PAYMENT_MODE_OPTIONS_PRODUCT_RECEIVING.find(
          (item) => item.name === data.payment_mode
        )?.label || data.payment_mode
      : ''

    const styles = `
      <style>
        * { box-sizing: border-box; }
        body {
          font-family: Arial, sans-serif;
          margin: 24px;
          color: #000;
        }
        .invoice-card {
          border: 1px solid #d4d4d4;
          padding: 16px;
        }
        .invoice-header {
          display: grid;
          grid-template-columns: ${headerEntity ? '1fr 1fr 1fr' : '1fr 1fr'};
          gap: 16px;
          align-items: center;
          border-bottom: 2px solid #d4d4d4;
          padding-bottom: 16px;
          margin-bottom: 16px;
        }
        .invoice-header-left { text-align: left; }
        .invoice-header-right { text-align: right; }
        .invoice-header-center {
          text-align: center;
          border-left: 1px solid #d4d4d4;
          border-right: 1px solid #d4d4d4;
          padding: 0 12px;
        }
        .invoice-title {
          font-size: 18px;
          font-weight: 700;
          margin: 0 0 12px;
        }
        .meta-line {
          font-size: 14px;
          line-height: 1.6;
        }
        .vendor-name { font-size: 22px; font-weight: 700; line-height: 1.2; }
        .vendor-contact, .vendor-bill-type {
          font-size: 13px;
          margin-top: 4px;
        }
        table.invoice-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
          border: 1px solid #d4d4d4;
          margin-bottom: 12px;
        }
        table.invoice-table th,
        table.invoice-table td {
          border: 1px solid #d4d4d4;
          padding: 6px 4px;
          text-align: left;
          vertical-align: top;
        }
        table.invoice-table th {
          background-color: #f5f5f5;
          font-weight: 600;
          font-size: 10px;
        }
        table.invoice-table .text-right { text-align: right; }
        table.invoice-table .td-wrap { word-break: break-word; }
        table.invoice-table tr.total-row { background-color: #f5f5f5; }
        .invoice-bottom {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
          margin-top: 12px;
        }
        .notes-box { flex: 1; font-size: 13px; }
        .notes-label { margin-bottom: 4px; font-weight: 600; }
        .approval-note { color: #d9534f; margin-top: 8px; font-weight: 500; }
        .payment-mode-row { margin-top: 10px; }
        .totals-box { width: 280px; font-size: 13px; }
        .total-line {
          display: flex;
          justify-content: space-between;
          gap: 12px;
          padding: 4px 0;
        }
        .total-line.strong { font-weight: 600; }
        .total-line.grand {
          border-top: 1px solid #d4d4d4;
          padding-top: 8px;
          margin-top: 4px;
          font-size: 14px;
        }
      </style>
    `

    const inner = `
      <div class="invoice-card">
        <div class="invoice-header">
          <div class="invoice-header-left">
            <div class="invoice-title">Product Receiving Invoice</div>
            <div class="meta-line"><strong>Received by:</strong> ${data.created_by || '-'}</div>
            <div class="meta-line"><strong>Invoice:</strong> ${data.invoice_number || '-'}</div>
          </div>
          ${
            headerEntity
              ? `
          <div class="invoice-header-center">
            <div class="vendor-name">${headerEntity.name || ''}</div>
            ${headerEntity.contact ? `<div class="vendor-contact">${headerEntity.contact}</div>` : ''}
            ${data.bill_type ? `<div class="vendor-bill-type">${data.bill_type}</div>` : ''}
          </div>
          `
              : ''
          }
          <div class="invoice-header-right">
            <div class="meta-line"><strong>Date:</strong> ${formatInvoiceDate(data.date_of_bill)}</div>
            <div class="meta-line"><strong>Time:</strong> ${formatInvoiceTime(data.time_of_bill || data.created_at_iso || data.date_of_bill)}</div>
          </div>
        </div>

        <table class="invoice-table">
          <thead>
            <tr>
              <th style="width:4%">SL No</th>
              <th style="width:18%">Product Name (Size)-Strength</th>
              <th style="width:9%">Category</th>
              <th style="width:8%">Batch No</th>
              <th style="width:9%">Expiry Date</th>
              <th style="width:5%">Qty</th>
              <th style="width:7%">Bonus Qty</th>
              <th style="width:7%" class="text-right">CPU</th>
              <th style="width:7%" class="text-right">RPU</th>
              <th style="width:9%" class="text-right">Sub total</th>
              ${(hasVendor || hasMultiSupplier) ? '<th style="width:17%">Suppliers/Manufacturer</th>' : ''}
            </tr>
          </thead>
          <tbody>
            ${rows}
            ${totalRow}
          </tbody>
        </table>

        <div class="invoice-bottom">
          <div class="notes-box">
            <div class="notes-label">Notes:</div>
            <div>${data.notes || ''}</div>
            ${
              data.payment_mode
                ? `<div class="payment-mode-row"><strong>Payment Mode: </strong>${paymentModeLabel}${data.payment_mode === 'CASH_IN_ACCOUNT' && data.bank_name ? ` - ${data.bank_name}` : ''}</div>`
                : ''
            }
            ${
              data.product_details?.some((p) => !p.is_approved)
                ? '<div class="approval-note">* marked products require approval from DG HealthCare</div>'
                : ''
            }
            ${
              data.pharma_details && !data.pharma_details.is_approved
                ? '<div class="approval-note">Supplier approval pending from DG HealthCare</div>'
                : ''
            }
          </div>
          <div class="totals-box">
            <div class="total-line strong"><span><strong>Amount (BDT):</strong></span><span><strong>${parseFloat(data.amount || 0).toFixed(2)}</strong></span></div>
            <div class="total-line"><span>Total TP (BDT):</span><span>${parseFloat(data.total_tp || 0).toFixed(2)}</span></div>
            <div class="total-line"><span>Total VAT (BDT):</span><span>${parseFloat(data.vat || 0).toFixed(2)}</span></div>
            <div class="total-line"><span>Trade Discount (${data.trade_discount_percentage || 0}%):</span><span>${parseFloat(data.trade_discount_amount || 0).toFixed(2)}</span></div>
            <div class="total-line grand"><span><strong>Total (BDT):</strong></span><span><strong>${parseFloat(data.total_amount || 0).toFixed(2)}</strong></span></div>
          </div>
        </div>
      </div>
    `

    if (!embedBody) {
      return `${styles}${inner}`
    }

    return `<!DOCTYPE html>
<html>
<head>
  <title>Invoice ${data.invoice_number}</title>
  <meta charset="UTF-8">
  ${styles}
</head>
<body>
  ${inner}
</body>
</html>`
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {addProductReceivingAlert && (
        <AcknowledgeScreen
          icon={<CheckPrimaryIcon />}
          alertType="success"
          alertMessage="New Product Receiving added Successfully!"
          main="New Product Receiving added Successfully!"
          sub="Lorem ipsum dolor sit amet consectetur. Ligula ut volutpat morbi ullamcorper"
        />
      )}
      <div className="pageBodyRightPanel">
        <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
          <button
            className="animated zoomIn btn btnPrimary"
            onClick={handleAddNewReceiving}
          >
            <AddIcon />
          </button>
        </div>
        <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter webVisible mb-5">
          <div className="pageBodyRightPanelHeading">Product Receiving</div>
          <div className="addProductBtn dFlex aiCenter">
            {permissions?.features?.[PERMISSION_FEATURE.PRODUCT_RECEIVING] ===
              PERMISSION_TYPE.MANAGE && (
              <button
                className="btn btnPrimary"
                onClick={handleAddNewReceiving}
              >
                ADD
              </button>
            )}
            <div className="pointer ml-4" onClick={() => props.onClose()}>
              <CloseIcon />
            </div>
          </div>
        </div>
        <div className="consolidateStrip dFlex jcSpaceBetween aiCenter">
          <div className="consolidateDataIcon dFlex">
            <ProductReceivingBlack />
          </div>
          <div className="consolidateDataText">
            Purchase({stats?.month_name}) <small>BDT</small>
          </div>
          <div className="consolidateData">
            {stats?.total_amount?.total_amount}
          </div>
        </div>

        {/* Search Filter */}
        <ProductReceivingFilter
          filterOptions={filterOptions}
          setFilterOptions={updateFilterOptions}
        />

        {/* Tab Navigation */}
        <div className="productReceivingWrapper mt-5">
          <ul className="tabs dFlex">
            <li
              className={`tabItem ${
                activeReceivingTab === PRODUCT_RECEIVING_TYPE.HOLD
                  ? 'active'
                  : ''
              }`}
              onClick={() => {
                setActiveReceivingTab(PRODUCT_RECEIVING_TYPE.HOLD)
                pagination.goToPage(1)
              }}
            >
              Hold
            </li>
            <li
              className={`tabItem ${
                activeReceivingTab === PRODUCT_RECEIVING_TYPE.RECEIVED
                  ? 'active'
                  : ''
              }`}
              onClick={() => {
                setActiveReceivingTab(PRODUCT_RECEIVING_TYPE.RECEIVED)
                pagination.goToPage(1)
              }}
            >
              Received
            </li>
          </ul>
          <div className="tabContent">
            <div className="tabPane dFlex">
              {productReceivingData &&
                productReceivingData.map((productReceiving, index) => {
                  const isHoldTab =
                    activeReceivingTab === PRODUCT_RECEIVING_TYPE.HOLD
                  const isReceivedTab =
                    activeReceivingTab === PRODUCT_RECEIVING_TYPE.RECEIVED
                  const hasManagePermission =
                    permissions?.features?.[
                      PERMISSION_FEATURE.PRODUCT_RECEIVING
                    ] === PERMISSION_TYPE.MANAGE
                  const hasViewPermission =
                    permissions?.features?.[
                      PERMISSION_FEATURE.PRODUCT_RECEIVING
                    ] === PERMISSION_TYPE.VIEW

                  let cardActions = []
                  if (isHoldTab) {
                    if (hasViewPermission || hasManagePermission) {
                      cardActions.push('EDIT')
                    }
                    if (hasManagePermission) {
                      cardActions.push('CONFIRM', 'REMOVE')
                    }
                  } else if (isReceivedTab) {
                    cardActions.push('DOWNLOAD', 'PRINT')
                  }

                  // Build sales display content with "Received by" as separate line (like Sales "Served by")
                  // Display vendor name if available, otherwise supplier name
                  // Check multiple possible field names for vendor
                  const vendorName =
                    productReceiving.vendor_name ||
                    productReceiving.vendor?.name ||
                    productReceiving.vendor_details?.name
                  const supplierName =
                    productReceiving.supplier_name ||
                    productReceiving.pharma_details?.name

                  let salesDisplayContent = null
                  if (isHoldTab) {
                    // Prioritize vendor name over supplier name
                    const displayName = vendorName
                      ? `Vendor: ${vendorName}`
                      : supplierName
                        ? `Supplier: ${supplierName}`
                        : 'N/A'
                    salesDisplayContent = displayName
                  } else if (isReceivedTab) {
                    // Prioritize vendor name over supplier name
                    const displayName = vendorName
                      ? `Vendor: ${vendorName}`
                      : supplierName
                        ? `Supplier: ${supplierName}`
                        : 'N/A'

                    // Display "Received by" on separate line with same style as Sales "Served by"
                    salesDisplayContent = (
                      <>
                        <div>{displayName}</div>
                        {productReceiving.received_by_name && (
                          <div
                            style={{
                              fontSize: '12px',
                              color: '#666',
                              marginTop: '2px',
                            }}
                          >
                            Received by: {productReceiving.received_by_name}
                          </div>
                        )}
                      </>
                    )
                  }

                  return (
                    <div
                      key={`product-receiving-${productReceiving.id || index}`}
                      className="cardWrap"
                    >
                      <Card
                        cardCrown={isReceivedTab ? 'Received' : 'Hold'}
                        primary={
                          productReceiving.status ===
                          PRODUCT_RECEIVING_TYPE.RECEIVED
                        }
                        headerSup={productReceiving.date_of_bill}
                        headerMain={productReceiving.invoice_number}
                        sales={salesDisplayContent}
                        cardRight={`BDT ${Number(
                          parseFloat(productReceiving.total_amount).toFixed(2)
                        )}`}
                        handleClick={(e) => {
                          if (e) {
                            e.preventDefault()
                            e.stopPropagation()
                          }
                          // A held invoice is an unfinished purchase - open it in
                          // edit mode so it can be continued, not the invoice view.
                          if (
                            productReceiving.status ===
                            PRODUCT_RECEIVING_TYPE.HOLD
                          ) {
                            handleEditProductReceiving(productReceiving)
                            return
                          }
                          getInvoiceDetails(productReceiving.id)
                        }}
                        users={cardActions.length > 0}
                        cardAction={cardActions}
                        onCardAction={(action) =>
                          handleCardAction(action, productReceiving)
                        }
                      />
                    </div>
                  )
                })}
            </div>
            <Pagination
              currentPage={pagination.page}
              totalPages={pagination.totalPages}
              onPageChange={pagination.goToPage}
              onPrevPage={pagination.prevPage}
              onNextPage={pagination.nextPage}
              onFirstPage={pagination.firstPage}
              onLastPage={pagination.lastPage}
              hasNextPage={pagination.hasNextPage}
              hasPrevPage={pagination.hasPrevPage}
              maxPageButtons={5}
            />
          </div>
        </div>
      </div>

      {open && (
        <AddProductReceiving
          open={open}
          handleDrawerToggle={handleDrawerToggle}
          handleSubmit={handleSubmit}
          serverError={serverError}
          clearServerError={clearServerError}
          editData={editingData}
        />
      )}

      <ViewInventory
        open={isViewInventoryActive}
        handleDrawerToggle={() =>
          setViewInventoryActive(!isViewInventoryActive)
        }
        invoiceData={invoiceData}
        onAction={handleCardAction}
      />

      {deleteInvoicePopup && (
        <PopupCard
          header={`Delete Invoice ${deleteInvoicePopup.invoice_number}`}
          body={`Are you sure you want to permanently delete invoice ${deleteInvoicePopup.invoice_number} for ${deleteInvoicePopup.supplier_name}? This action cannot be undone.`}
        >
          <button
            className="btn btnPrimaryOutlined dFlex"
            onClick={() => setDeleteInvoicePopup(false)}
            disabled={isDeletingInvoice}
          >
            Cancel
          </button>
          <button
            className="btn btnDanger dFlex"
            onClick={() => handleDeleteInvoice(deleteInvoicePopup)}
            disabled={isDeletingInvoice}
          >
            {isDeletingInvoice ? 'Deleting...' : 'Delete Invoice'}
          </button>
        </PopupCard>
      )}

      {confirmInvoicePopup && (
        <PopupCard
          header={`Confirm Invoice ${confirmInvoicePopup.invoice_number}`}
          body={`Are you sure you want to confirm invoice ${confirmInvoicePopup.invoice_number} for ${confirmInvoicePopup.supplier_name}? This will move the invoice from Hold to Received status.`}
        >
          <button
            className="btn btnPrimaryOutlined dFlex"
            onClick={() => setConfirmInvoicePopup(false)}
            disabled={isConfirmingInvoice}
          >
            Cancel
          </button>
          <button
            className="btn btnPrimary dFlex"
            onClick={() => handleConfirmInvoice(confirmInvoicePopup)}
            disabled={isConfirmingInvoice}
          >
            {isConfirmingInvoice ? 'Confirming...' : 'Confirm Invoice'}
          </button>
        </PopupCard>
      )}

      {/* Alert Modal (replaces browser alert popups) */}
      {alertModal.show && (
        <PopupCard header={alertModal.header} body={alertModal.body}>
          <button
            className="btn btnPrimary dFlex"
            onClick={handleCloseAlertModal}
          >
            OK
          </button>
        </PopupCard>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProductReceivingAlertAction: (payload) =>
      dispatch(addProductReceivingAlertAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductReceiving)
